import { reloadRecentSearch } from "@containers/SearchHistory/RecentSearch";
import trackingEventDictionary from "@core/dictionary/tracking-event";
import { requestObjectTypeDictionary, searchPhraseDictionary, tabHeadingDictionary } from "@core/global/global-country-dictionary";
import { getChemicalSearchName, getTitleCase } from "@utils/utils";
import { useAnalytics, createEventData } from "@core/analytics";
import { useSelector } from "react-redux";

const PostSearchResults = ({ data, isSelectedFromAutoSuggest, isClickedPostSearchSugg, setClickPostSearchSugg, search, searchCategory, callingSearch, currentTab, tabKeyWords, recentSearchData }) => {
  const { trackEvent, setUser } = useAnalytics();
  const { category, user_search, hs_info } = data ?? {};
  const { hs_code } = hs_info ?? {};
  const userDetails = useSelector((state) => state.userDetails);
  const userData = userDetails.userData;
  const email = userData.email;
  const redirectToTab = (tab, iscomingFromHsCode, iscomingFromProduct, product) => {
    let data = {};
    data.redirectionTab = iscomingFromHsCode || iscomingFromProduct ? currentTab : tab !== "" ? tab : null;
    data.searchParameters = {
      searchedItem: iscomingFromHsCode ? hs_code : iscomingFromProduct ? product + (Number.isInteger(+search) ? "" : "||" + search) : user_search,
      searchCategory: iscomingFromHsCode ? searchPhraseDictionary.product_hscode : iscomingFromProduct ? searchPhraseDictionary.product_description : tab.toLowerCase(),
      dataSource: "multi_country",
      matchType: "contains",
    };
    callingSearch(requestObjectTypeDictionary.search, undefined, undefined, data);
  };

  return !isSelectedFromAutoSuggest && isClickedPostSearchSugg === false && search === "" && recentSearchData?.length > 0 ? (
    <div className="tw-flex tw-justify-center">
      <div className="tw-flex tw-items-center tw-gap-2 tw-bg-primary-purple-50 tw-px-2 tw-py-1 tw-rounded-lg">
        <span className="tw-text-sm tw-font-medium">Recent Searches</span>
        {recentSearchData.slice(0, 3).map((row) => {
          let multipleSearchSeparators = "$**$";
          let userSearch = row.search.join(` ${"$**$"} `).replace(/  +/g, " ").trim();
          return (
            <span key={row.user_search_date} className="tw-flex tw-gap-1 tw-items-center tw-bg-white tw-py-1 tw-px-2 tw-shadow-button tw-rounded-[54px]">
              <span className="tw-text-primary-purple-600 tw-text-sm tw-font-normal tw-underline tw-cursor-pointer" onClick={() => reloadRecentSearch(row)}>
                {row.is_chemical
                  ? getChemicalSearchName(userSearch).slice(0, 45).includes(multipleSearchSeparators)
                    ? getChemicalSearchName(userSearch)
                        .slice(0, 45)
                        .split(multipleSearchSeparators)
                        .map((name, index) => (
                          <span key={name}>
                            {name} {index + 1 < getChemicalSearchName(userSearch).slice(0, 45).split(multipleSearchSeparators).length ? <span>or</span> : ""}
                          </span>
                        ))
                    : getChemicalSearchName(userSearch).slice(0, 45)
                  : getTitleCase(userSearch).slice(0, 45)?.includes(multipleSearchSeparators)
                    ? getTitleCase(userSearch)
                        .slice(0, 45)
                        .split(multipleSearchSeparators)
                        .map((name, index) => (
                          <span key={name}>
                            {name} {index + 1 < getTitleCase(userSearch).slice(0, 45).split(multipleSearchSeparators).length ? <span>or</span> : ""}
                          </span>
                        ))
                    : getTitleCase(userSearch).slice(0, 45)}
                {((row.is_chemical && getChemicalSearchName(userSearch).length > 45) || (!row.is_chemical && getTitleCase(userSearch).length > 45)) && "..."}
              </span>
            </span>
          );
        })}
      </div>
    </div>
  ) : (searchCategory === searchPhraseDictionary.product_description || !isSelectedFromAutoSuggest) && isClickedPostSearchSugg === false && search !== "" ? (
    <div className="tw-flex tw-justify-center">
      {category === "company" && !search?.includes("||") ? (
        <div className="tw-flex tw-items-center tw-gap-2 tw-bg-primary-purple-50 tw-px-2 tw-py-1 tw-rounded-lg">
          <span className="tw-text-sm tw-font-medium">
            Refine your search for <span className="tw-capitalize tw-text-sm tw-font-semibold">{user_search}</span>
          </span>
          {tabKeyWords?.importers && (
            <span
              className="tw-flex tw-items-center tw-gap-1 tw-bg-white tw-py-1 tw-px-2 tw-shadow-button tw-rounded-[54px] tw-cursor-pointer"
              onClick={() => {
                redirectToTab(tabHeadingDictionary.importers, false, false, null);
                setClickPostSearchSugg(true);
                trackEvent(
                  trackingEventDictionary.refineSearchViewAsConsigneeClicked,
                  createEventData("Post Search", {
                    url: window.location.pathname,
                  })
                );
                setUser(email);
              }}>
              <span className="tw-flex tw-items-center tw-justify-center tw-text-xs tw-h-4 tw-w-4 tw-rounded-lg tw-text-white tw-bg-[#2a3791]">C</span>
              <span className="tw-text-sm tw-font-normal">View as a Importer</span>
            </span>
          )}
          {tabKeyWords?.exporters && (
            <span
              className="tw-flex tw-items-center tw-gap-1 tw-bg-white tw-py-1 tw-px-2 tw-shadow-button tw-rounded-[54px] tw-cursor-pointer"
              onClick={() => {
                redirectToTab(tabHeadingDictionary.exporters, false, false, null);
                setClickPostSearchSugg(true);
                trackEvent(
                  trackingEventDictionary.refineSearchViewAsShipperClicked,
                  createEventData("Post Search", {
                    url: window.location.pathname,
                  })
                );
                setUser(email);
              }}>
              <span className="tw-flex tw-items-center tw-justify-center tw-text-xs tw-h-4 tw-w-4 tw-rounded-lg tw-text-white tw-bg-[#07710b]">S</span>
              <span className="tw-text-sm tw-font-normal">View as a Exporter</span>
            </span>
          )}
        </div>
      ) : category === "product_description" && !search?.includes("||") ? (
        <div className="tw-flex tw-items-center tw-gap-2 tw-bg-primary-purple-50 tw-px-2 tw-py-1 tw-rounded-lg">
          <span className="tw-text-sm tw-font-medium">Refine your search with HS Code</span>
          <span
            className="tw-flex tw-items-center tw-gap-1 tw-bg-white tw-py-1 tw-px-2 tw-shadow-button tw-rounded-[54px] tw-text-primary-purple-600  tw-text-sm tw-font-normal tw-underline tw-cursor-pointer"
            onClick={() => {
              redirectToTab(tabHeadingDictionary.analytics, true, false, null);
              setClickPostSearchSugg(true);
              trackEvent(
                trackingEventDictionary.refineSearchSuggestionHsClassificationSuggestionClicked,
                createEventData("Post Search", {
                  url: window.location.pathname,
                })
              );
              setUser(email);
            }}>
            {hs_info?.hs_code}
          </span>
          <span className="tw-text-sm tw-font-medium">Or by adding more keywords</span>
          <span className="tw-flex tw-gap-1 tw-items-center tw-bg-white tw-py-1 tw-px-2 tw-shadow-button tw-rounded-[54px]">
            {hs_info?.related_products.map((product, index) => (
              <span
                key={product}
                onClick={() => {
                  redirectToTab(tabHeadingDictionary.analytics, false, true, product);
                  setClickPostSearchSugg(true);
                  trackEvent(
                    trackingEventDictionary.refineSearchSuggestionAddProductKeywordsClicked,
                    createEventData("Post Search", {
                      url: window.location.pathname,
                    })
                  );
                  setUser(email);
                }}
                className="tw-text-primary-purple-600 tw-text-sm tw-font-normal tw-underline tw-cursor-pointer">
                {product + (index === hs_info?.related_products.length - 1 ? "" : ", ")}
              </span>
            ))}
          </span>
        </div>
      ) : (
        <></>
      )}
    </div>
  ) : (
    <></>
  );
};

export default PostSearchResults;
